import React from 'react';
import { useChatContext } from 'stream-chat-react';

import { HamburgerIcon } from '../../assets';

import type { StreamChatGenerics } from '../../types';

type Props = {
  onCreateChannel?: () => void;
  platformType:string,
  languageCode:any,
  eventName:string
};

/**
 * Header at top of channel sidebar with hamburger menu and title
 * Shows event name for moderators, "Messaging" for regular users
 * MEMOIZATION:
 * Wrapped in React.memo to prevent unnecessary re-renders
 * Only updates when props change
 */
const MessagingChannelListHeader = React.memo((props: Props) => {
  const { onCreateChannel,platformType, languageCode, eventName } = props;

  /**
   * Get Stream Chat client to access user role
   * Determines whether to show event name or "Messaging"
   */
  const { client } = useChatContext<StreamChatGenerics>();
  
  /**
   * HEADER TEXT LOGIC
   * 
   * Moderators see event name (gives context of which event they're moderating)
   * Regular users see "Messaging" (generic label)
   */
  const headertext = client.user?.role === 'moderator' ? eventName :  languageCode['Messaging']; 

  return (
      <div className='messaging__channel-list__header'>
        {/* Hamburger menu button */}
        <button
          className= 
          {(platformType==="Mobile")?
            `messaging__channel-list__header__button_mobile`:'messaging__channel-list__header__button'}
          onClick={onCreateChannel}>
          <HamburgerIcon />
        </button>
        
        {/* Header title */}
        <div className={`messaging__channel-list__header__name`}>{headertext}</div>
      </div>
  );
});

export default React.memo(MessagingChannelListHeader);
